import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faHouse,
  faCreditCard,
  faGraduationCap,
  faEnvelope,
  faFilter,
  faBuildingColumns,
  faMoneyBills,
  faClockRotateLeft,
  faClock,
  faUser,
  faLocationPin,
  faPen,
  faBars,
  faExpand,
  faEye,
  faEyeSlash,
  faArrowDown,
  faQrcode,
  faBookOpen,
  faListCheck,
  faLock,
  faNewspaper,
  faCalendarCheck,
  faChevronRight,
  faChevronLeft,
  faChevronDown,
  faMoneyBill,
  faMoneyBillTransfer,
  faFile,
  faQuran,
  faCheckCircle,
  faHourglassHalf,
  faTimesCircle,
  faTriangleExclamation,
  faCalendarAlt,
  faTrophy
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faHouse, faCreditCard, faGraduationCap, faEnvelope, faFilter,
  faBuildingColumns, faMoneyBills, faClockRotateLeft, faClock, faUser,
  faLocationPin, faPen, faBars, faExpand, faEye, faEyeSlash, faArrowDown,
  faQrcode, faBookOpen, faListCheck, faLock, faNewspaper, faCalendarCheck,
  faChevronRight, faChevronLeft, faChevronDown, faMoneyBill, faMoneyBillTransfer, 
  faFile, faQuran,faCheckCircle, faHourglassHalf, faTimesCircle,faTriangleExclamation, 
  faCalendarAlt, faTrophy
);
